/**
 * La última hora de Business Central que vio este equipo.
 *
 * Business Central la manda en la cabecera `Date` de cada respuesta y la expone
 * al navegador (`Access-Control-Expose-Headers: Date, …`, medido el 14/09/2026
 * sobre CRI DEV). La anota el interceptor de `bcApi` (apiClients.js), así que
 * comprobar el reloj del equipo no cuesta ninguna llamada de más.
 */

let ultima = null;

/**
 * @param {object} cabeceras Cabeceras de la respuesta (objeto plano o AxiosHeaders).
 * @param {number} [ahora]   Hora del equipo al recibirla, en ms.
 * @returns {boolean} `true` si había una fecha legible.
 */
export const anotarHoraDelServidor = (cabeceras, ahora = Date.now()) => {
  const texto =
    (typeof cabeceras?.get === "function" ? cabeceras.get("date") : undefined) ??
    cabeceras?.date ??
    cabeceras?.Date;

  const servidor = Date.parse(texto || "");
  if (!Number.isFinite(servidor)) return false;

  ultima = { servidor, local: ahora };
  return true;
};

/** @returns {{servidor: number, local: number}|null} */
export const ultimaHoraDelServidor = () => ultima;
